import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './navigation/Navbar.js';
import Home from './views/Home.js';
import News from './views/News.js';
import ArticleDetail from './views/ArticleDetail.js';
import Contact from './views/Contact.js';
import About from './views/About.js';
import Events from './views/Events.js';
import Emarket from './views/Emarket.js';
import ComingSoon from './views/ComingSoon.js';

import ScrollToTop from './components/ScrollToTop.js';
import EventCalendar from './components/Calendar.js';

import './App.css';
import { CookiesProvider } from 'react-cookie';
import Membership from './views/Membership.js';
import CantoConnect from './views/subviews/CantoConnect.js';
import Footer from './components/Footer.js';
import MembershipFaq from './views/subviews/MembershipFaq.js';
import MembershipListing from './views/subviews/MembershipListing.js';
import MembershipBenefits from './views/subviews/MembershipBenefits.js';
import MembershipApply from './views/subviews/MembershipApply.js';
import Board from './views/subviews/Board.js';
import AboutMain from './views/subviews/AboutMain.js';
import MembershipCategories from './views/subviews/MembershipCategories.js';
import CantoConference from './views/subviews/CantoConference.js';
import Secretariat from './views/subviews/Secretariat.js';
import WorkingCommittee from './views/subviews/WorkingCommittee.js';
import InnovationChallenge from './views/subviews/InnovationChallenge.js';
import CantoConversations from './views/subviews/CantoConversations.js';
import ContactForms from './views/dashboard/modules/ContactForms.js';
import Dashboard from './views/dashboard/Dashboard.js';
import CantoConnectDash from './views/dashboard/modules/CantoConnectDash.js';
import CantoConferenceDash from './views/dashboard/modules/CantoConferenceDash.js';
import BannersDash from './views/dashboard/modules/BannersDash.js';
import { SlideoutProvider } from './hooks/SlideoutContext.js';
import { ToastProvider } from './hooks/ToastContext.js';
import FaqsAdmin from './views/dashboard/modules/FaqsAdmin.js';
import PressReleasesAdmin from './views/dashboard/modules/PressReleasesAdmin.js';
import Cancion from './views/subviews/Cancion.js';
import TestimonialsAdmin from './views/dashboard/modules/TestimonialsAdmin.js';
import ConversationsDash from './views/dashboard/modules/ConversationsDash.js';
import MembersAdmin from './views/dashboard/modules/MembersAdmin.js';
import History from './views/dashboard/modules/History.js';
import PublicationsDash from './views/dashboard/modules/PublicationsDash.js';
import CancionCurrentIssueDash from './views/dashboard/modules/CancionCurrentIssueDash.js';
import AgmDocuments from './views/subviews/AgmDocuments.js';
import AgmDocumentsDash from './views/dashboard/modules/AgmDocumentsDash.js';
import PrivacyPolicy from './views/subviews/PrivacyPolicy.js';
import MinisterialAward from './views/subviews/MinisterialAward.js';
import NotFound from './views/NotFound.js';

function AppContent() {
  const location = useLocation();
  const showNavFooter = !location.pathname.startsWith('/dashboard');

  return (
    <>
      {showNavFooter && <Navbar />}
      <ScrollToTop />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/membership' element={<Membership />} />
        <Route path='/membership/categories' element={<MembershipCategories />} />
        <Route path='/membership/benefits' element={<MembershipBenefits />} />
        <Route path='/membership/working-committees' element={<WorkingCommittee />} />
        <Route path='/membership/faqs' element={<MembershipFaq />} />
        <Route path='/membership/listing' element={<MembershipListing />} />
        <Route path='/membership/apply' element={<MembershipApply />} />
        <Route path='/news' element={<News />} />
        <Route path='/article/:id' element={<ArticleDetail />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/about/mission' element={<About />} />
        <Route path='/about/main' element={<AboutMain />} />
        <Route path='/about/board' element={<Board />} />
        <Route path='/about/secretariat' element={<Secretariat />} />
        <Route path='/events' element={<Events />} />
        <Route path='/events/canto-connect/:id' element={<CantoConnect />} />
        <Route path='/events/canto-conference' element={<CantoConference />} />
        <Route path='/events/innovation-challenge' element={<InnovationChallenge />} />
        <Route path='/events/canto-conversations' element={<CantoConversations />} />
        <Route path='/publications/press-releases' element={<News />} />
        <Route path='/publications/cancion' element={<Cancion />} />
        <Route path='/events/Calendar' element={<EventCalendar />} />
        <Route path='/events/ministerial-award' element={<MinisterialAward />} />
        <Route path='/events/presentations' element={<ComingSoon />} />
        <Route path='/events/agm-documents' element={<AgmDocuments />} />
        <Route path='/emarket' element={<Emarket />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/dashboard' element={<Dashboard />}>
          {/* <Route index element={<ContactForms />} /> */}
          <Route index path='home_banners' element={<BannersDash />} />
          <Route path='testimonials' element={<TestimonialsAdmin />} />
          <Route path='canto_connect' element={<CantoConnectDash />} />
          <Route path='canto_conference' element={<CantoConferenceDash />} />
          <Route path='canto_conversations' element={<ConversationsDash />} />
          <Route path='contact_forms' element={<ContactForms />} />
          <Route path='press-releases' element={<PressReleasesAdmin />} />
          <Route path='faqs' element={<FaqsAdmin />} />
          <Route path='members' element={<MembersAdmin />} />
          <Route path='history' element={<History />} />
          <Route path='press_releases' element={<PublicationsDash />} />
          <Route path='cancion_current_issue' element={<CancionCurrentIssueDash />} />
          <Route path='agm_documents' element={<AgmDocumentsDash />} />
        </Route>
        <Route path='*' element={<NotFound />} />
      </Routes>
      {showNavFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <CookiesProvider>
      <ToastProvider>
        <SlideoutProvider>
          <Router>
            <AppContent />
          </Router>
        </SlideoutProvider>
      </ToastProvider>
    </CookiesProvider>
  );
}

export default App;
